export default function Badge({
  children,
  variant = 'gold', // 'gold' | 'navy' | 'success' | 'danger' | 'warning' | 'info' | 'neutral'
  icon: Icon,
  className = '',
}) {
  return (
    <span className={`badge badge--${variant} ${className}`}>
      {Icon && <Icon style={{ width: 12, height: 12 }} />}
      {children}
    </span>
  );
}
